import { NO_MED_REC_REASONS } from "@thalamos/aspire-common";

export interface ReasonOptions {
  value: string;
  descriptionPrompt?: string;
  descriptionRequired?: boolean;
}

// Derived from the single source of truth in @thalamos/aspire-common so the
// dropdown and the anonymisation allowlist can't drift. "Other" additionally
// requires accompanying free text.
export const NO_MED_REC_REASON_OPTIONS: readonly ReasonOptions[] =
  NO_MED_REC_REASONS.map((value) =>
    value === "Other" ? { value, descriptionRequired: true } : { value },
  );
